import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { colors, Toolbar } from '@material-ui/core'
import customLogo from '../../assets/images/logos/conduiit(twoeyes).svg'
import customDarkLogo from '../../assets/images/logos/conduiit(infrev).svg'
import Image from '../../shared/Image'
import { isLightMode } from '../../utils/utils'
import CustomButton from '../../shared/CustomButton'
import changeRoute from '../../containers/changeRoute'

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    background: theme.palette.white,
    borderBottom: `1px solid ${colors.grey[200]}`,
  },

  header: {
    position: 'sticky',
    top: 0,
    right: 0,
    left: 0,
    zIndex: 99,
    padding: [[9, 0]],
    backgroundColor: '#fff',
    '& button': {
      fontWeight: 900,
    },
  },
  toolbar: {
    maxWidth: 1366,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(0, 2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('1450')]: {
      maxWidth: 1199,
    },
    [theme.breakpoints.down('960')]: {
      padding: theme.spacing(0, 5),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2),
    },
  },
  logoContainer: {
    width: 400,
    [theme.breakpoints.up('md')]: {
      width: 180,
    },
    [theme.breakpoints.down('md')]: {
      width: 150,
    },
    [theme.breakpoints.down('467')]: {
      width: 125,
    },
    [theme.breakpoints.down('375')]: {
      width: 100,
    },
  },
  logoImage: {
    width: '100%',
    height: '100%',
  },
  headerBtn: {
    display: 'flex',
    '& button': {
      [theme.breakpoints.down('425')]: {
        fontSize: 12,
        padding: [[7, 10]],
        minWidth: 'inherit',
      },
    },
  },
  show: {
    display: 'block',
    fontSize: 14,
    color: '#ffffff',
    border: '1px solid #7c44ef',
    borderRadius: 5,
    marginLeft: 5,
    transition: '9s',
    '& a': {
      color: '#fff',
    },
  },
  hide: {
    display: 'none',
    transition: '9s',
  },
  loginBtn: {
    border: '1px solid #767676',
    borderRadius: 5,
    minWidth: 147,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '17px',
    textTransform: 'uppercase',
    color: '#767676',
    padding: [[17, 15]],
    [theme.breakpoints.down('xs')]: {
      minWidth: 110,
      padding: [[10, 15]],
    },
  },
}))

const Topbar = (props) => {
  const { route } = changeRoute()
  const { onSidebarOpen, className, showButton, ...rest } = props
  const [isLightModeTheme, setLightModeTheme] = useState(false)

  useEffect(() => {
    setLightModeTheme(isLightMode())
  }, [])

  // useEffect(() => {
  //   const header = document.querySelector('header')

  //   document.addEventListener('scroll', () => {
  //     console.log('Hello')
  //     var scroll_position = window.scrollY
  //     if (scroll_position > 30) {
  //       header.classList.add(classes.sticky)
  //     } else {
  //       header.classList.remove(classes.sticky)
  //     }
  //   })
  // })

  // useEffect(() => {
  //   // window.addEventListener('scroll', () => {
  //   console.log('test1')
  //   var scroll = window.scrollY
  //   if (scroll >= 64) {
  //     console.log('heloo2')

  //     // setHeaderSticky('top')
  //   } else {
  //     // if (path.includes("Information")) {
  //     // setHeaderSticky('top')
  //     // } else {
  //     // setHeaderSticky('normal')
  //     // }
  //     console.log('heloo')
  //   }
  //   // })
  // }, [window.scroll])

  // console.log('window.scroll', window.scroll)

  const classes = useStyles()

  return (
    <div className={classes.header} id="topHeader">
      <header>
        <Toolbar className={clsx(classes.toolbar, className)} {...rest}>
          <div className={classes.logoContainer}>
            <Link to="/home" title="Conduiit">
              <Image
                className={classes.logoImage}
                src={isLightModeTheme ? customLogo : customDarkLogo}
                alt="Conduiit"
                lazy={false}
              />
            </Link>
          </div>
          {/* <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <CustomButton
            color="primary"
            variant="outlined"
            size="small"
            onClick={() => route('/create-company')}
          >
            Create Company
          </CustomButton>
        </div> */}
          <div className={classes.headerBtn}>
            <CustomButton
              color="primary"
              variant="outlined"
              size="large"
              className={classes.loginBtn}
              onClick={() => route('/login')}
            >
              Login
            </CustomButton>
            <CustomButton
              variant="contained"
              color="primary"
              size="large"
              id="bookBtn"
              className={`${showButton ? classes.show : classes.hide}`}
            >
              <a
                href="https://getgist.me/sh29229pn/schedule"
                target="_blank
          "
              >
                BOOK A DEMO
              </a>
            </CustomButton>
          </div>
        </Toolbar>
      </header>
    </div>
  )
}

Topbar.propTypes = {
  className: PropTypes.string,
}

export default Topbar
